import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "../assets/vendor/swiper/swiper-bundle.min.css";
import {
  Navigation,
  Pagination,
  Autoplay,
  EffectCoverflow,
} from "swiper/modules";
import { FaStar, FaQuoteLeft, FaQuoteRight } from "react-icons/fa";
import bgImg from "../assets/img/baner.webp";
import face1 from "../assets/img/blog/face1.jpg";
import face2 from "../assets/img/blog/face2.jpg";
import face3 from "../assets/img/blog/face3.jpg";
import face4 from "../assets/img/blog/face4.jpg";
import face5 from "../assets/img/blog/face6.jpg";

const testimonials = [
  {
    img: face1,
    name: "Saksham Shrivastava",
    role: "Client",
    quote:
      "Since day one, the company has shown a strong commitment to creating a positive and inclusive work environment. The onboarding process was smooth, giving me the tools and information I needed to start right away. The emphasis on a collaborative culture has made it easy to integrate into different teams and departments, promoting a sense of unity across the organization.",
  },
  {
    img: face2,
    name: "Kapil Rai",
    role: "Client",
    quote:
      "Our experience with this company has been outstanding. Their team is highly skilled, responsive, and dedicated to delivering top-notch solutions. They consistently exceed expectations, ensuring our business operates seamlessly. A true partner in technology.",
  },
  {
    img: face3,
    name: "Fahad Masood",
    role: "Client",
    quote:
      "EduAdminHub by Oethical Technology is an excellent all-in-one solution for managing schools and colleges. I am currently working on this project, and I can confidently say it is highly flexible and built with top-level security. The code is well-optimized and runs smoothly without any bugs. It simplifies everything from admissions to daily administration, making it perfect for both government and private institutions.",
  },
  {
    img: face4,
    name: "Ankit Kumar",
    role: "Client",
    quote:
      "I would highly recommend oethical Technology to anyone who is looking for a great place to work. The company culture is fantastic, and the team is extremely supportive.",
  },
  {
    img: face5,
    name: "Sumita Badola",
    role: "Client",
    quote:
      "experience was good ...i recently met the team of the organisation all member are really talented in term of tech and management...",
  },
];

const TestimonialsSection = () => {
  //=================== main_return_function =============//
  return (
    <section
      id="testimonials"
      className="testimonials section dark-background font-[poppins]"
    >
      <div className="container section-title" data-aos="fade-up">
        <h2 className="font-[poppins] !font-bold !text-[24px] md:!text-[34px]">
          Testimonials
        </h2>
        <p>What our clients say about our trusted, innovative solutions.</p>
      </div>
      <img src={bgImg} className="testimonials-bg" alt="" />
      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <Swiper
          modules={[Navigation, Pagination, Autoplay, EffectCoverflow]}
          effect={"coverflow"}
          grabCursor={true}
          centeredSlides={true}
          coverflowEffect={{
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          }}
          loop={true}
          speed={600}
          spaceBetween={30}
          autoplay={{ delay: 5000 }}
          slidesPerView={1}
          breakpoints={{
            640: { slidesPerView: 1, spaceBetween: 20 },
            1024: { slidesPerView: 3, spaceBetween: 30 },
          }}
          pagination={{ clickable: true }}
          className="swiper"
        >
          {testimonials.map((testimonial, index) => (
            <SwiperSlide key={index} className="pt-[10px]">
              <div className="bg-white shadow-lg rounded-lg p-6 flex flex-col items-center text-center max-w-md mx-auto">
                <img
                  src={testimonial.img}
                  className="w-20 h-20 rounded-full object-cover mb-4 border-4 border-[#9bd66c]"
                  alt={testimonial.name}
                />
                <h3 className="text-lg font-semibold text-[#1e2637] font-[poppins]">
                  {testimonial.name}
                </h3>
                <h4 className="text-sm text-[#666] mb-2">{testimonial.role}</h4>

                <div className="flex text-yellow-400 mb-3">
                  {[...Array(5)].map((_, i) => (
                    <FaStar key={i} />
                  ))}
                </div>

                <p className="text-gray-600 text-sm italic relative">
                  <FaQuoteLeft className="inline-block text-[#9bd66c] mr-1" />
                  <span>{testimonial.quote}</span>
                  <FaQuoteRight className="inline-block text-[#9bd66c] ml-1" />
                </p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default TestimonialsSection;
